import { Flex, Tooltip, TooltipProps } from '@chakra-ui/react'
import { PropsWithChildren, useCallback, useRef, useState } from 'react'

export const useCopied = (text: string) => {
  const [copied, setCopied] = useState(false)
  const copiedTimeout = useRef<any>(null)
  const onClick = useCallback(() => {
    setCopied(true)
    copiedTimeout.current = setTimeout(() => {
      setCopied(false)
    }, 2000)
    navigator.clipboard.writeText(text)
  }, [text])

  return { copied, onClick }
}

export const CopyTooltip = ({
  children,
  label,
  prefix,
  suffix,
  multiLine,
  ...props
}: PropsWithChildren<
  TooltipProps & {
    label: string
    prefix?: string
    multiLine?: boolean
    suffix?: string
  }
>) => {
  const { copied, onClick } = useCopied(label)
  return (
    <Tooltip
      placement="top"
      width="auto"
      hasArrow
      closeOnClick={false}
      lineHeight={1.2}
      px={multiLine ? 3 : 2}
      py={multiLine ? 1 : 1}
      textAlign="center"
      whiteSpace="pre-wrap"
      {...props}
      label={
        copied
          ? 'Copied!'
          : `${prefix ? `${prefix} ` : ''}${label}${multiLine ? '\n' : ' - '}Click to copy${
              suffix ? ` ${suffix}` : ''
            }`
      }>
      <Flex cursor="pointer" onClick={onClick}>
        {children}
      </Flex>
    </Tooltip>
  )
}
